import { Component, Input, OnInit } from '@angular/core';
import {
  RankingOfficeAverage,
  RankingOfficeGroup,
} from 'src/app/models/ranking-office.model';
import { RankingCategoriesAveragesService } from 'src/app/services/ranking-categories-averages';
import { RankingCategoriesGroupService } from 'src/app/services/ranking-categories-group';
import { UtilsService } from 'src/app/services/utils.service';

@Component({
  selector: 'app-ranking-table-averages',
  templateUrl: './ranking-table-averages.component.html',
  styleUrls: ['./ranking-table-averages.component.scss'],
})
export class RankingTableAveragesComponent implements OnInit {
  @Input() value!: string;
  averages: RankingOfficeAverage[] = [];
  groups: RankingOfficeGroup[] = [];
  isLoading: boolean = false;

  constructor(
    private readonly rankingCategoriesAveragesService: RankingCategoriesAveragesService,
    private readonly rankingCategoriesGroupService: RankingCategoriesGroupService,
    public utilsService: UtilsService
  ) {}

  ngOnInit(): void {
    this.loadData();
  }

  loadData(): void {
    this.rankingCategoriesAveragesService
      .get(this.value)
      .then((response) => {
        response.data.promediosCategorias.forEach(
          (average: RankingOfficeAverage) => {
            this.averages.push(average);
            this.isLoading = false;
          }
        );
      })
      .catch(() => {
        this.isLoading = false;
      });

    this.rankingCategoriesGroupService.getAll().then((response) => {
      response.data.gruposCategorias.forEach((gruop: RankingOfficeGroup) => {
        let descriptionParse = gruop.descripcion.split('-');
        gruop.location = descriptionParse[0];
        gruop.antiquity = descriptionParse[1];
        this.groups.push(gruop);
      });
    });
  }
}
